import Vue from 'vue';

export default {
  // 获取账户信息
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },
  // 重置密码
  updatePassWord (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/updatePassWord', params);
  },
  // 验证短信验证码
  authenticate (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/authenticate', params);
  },
  // 检查用户是否有在途订单
  checkProcessingOrder () {
    return Vue.axios.get('/api/v1.0/chanquan/bid/checkProcessingOrder');
  },
  // 修改信息员
  updateUserInfo (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/updateUserInfo', params);
  },
  // 获取当前申请状态
  getCurrentUserStatus () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getCurrentUserStatus');
  },
  // 获取变更后的手机号码
  getChangeMobile () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getChangeMobile');
  },
  // 验证法人变更的信息
  submitChangeLegal (params) {
    return Vue.axios.post('/api/v1.0/chanquan/user/submitChangeLegal', params);
  }
};
